export const keys = {
    DEVICE_ID: 'deviceId',
    DEVICE_IDS: 'deviceIds',
    BEARER_TOKEN: 'bearerToken',
    LANGUAGE: 'language',
    IS_FLASHLIGHT_ON: 'isFlashlightOn',
    DEMO_MODE_UNTIL: 'demoModeUntil',
    ID_BLACKLIST: 'idBlacklist',
};
//# sourceMappingURL=keys.js.map